import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import styled from "styled-components";

import { newPath } from '@/utils/index'

export const Root = styled.ul`
  display: flex;

  &.sub-mobile {

    &.news {
      flex-direction: column;

      li {
        display: flex;
        align-items: center;
        margin-top: 20px;
        border: none;
        background: none;
        padding: 0;

        & > div:first-child {
          width: 40%;
          flex-shrink: 0;
          margin-right: 10px;
        }

        .title, .desc {
          margin-top: 0;
          -webkit-line-clamp: 1;
          height: 14px;
          line-height: 14px;
          font-size: 12px;
        }

        .desc {
          -webkit-line-clamp: 1;
          margin: 6px 0 15px;
        }

        .user {
          height: auto;
          padding: 0;
          background: none;

          span {
            display: none;
          }
        }
      }
    }

    li {
      width: 100%;
      margin-right: 0;
      padding: 8px;

      &:hover {
        box-shadow: none;
        transform: none;
      }

      & > div:first-child {
        width: 100%;

        & > img {
          width: 100%;
          height: auto;
        }
      }
    }

    .p10 {
      padding: 0;
    }

    .title {
      margin-top: 20px;
      padding: 0;
      font-size: 16px;
      height: 40px;
      line-height: 20px;
    }

    .desc {
      margin-top: 10px;
      /* margin-bottom: 15px; */
      font-size: 12px;
      height: 28px;
      line-height: 14px;
    }

    .info {
      span {
        transform: scale(0.85);
      }
    }

    .user {
      height: 20px;
      padding: 0 0 0 3px;

      div, img {
        margin-right: 0;
      }
    }
  }

  li {
    width: calc((100% - 60px) / 3);
    margin-right: 30px;
    padding: 10px 10px 20px;
    background: #FFFFFF;
    border: 1px solid #eee;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    transition: all .4s ease-out 0s;

    &:hover {
      transform: scale(1.03);
      box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.2);
    }

    div > img {
      display: block;
      border-radius: 10px;
    }

    &:nth-child(n+3) {
      margin-right: 0;
    }

    .p10 {
      padding: 0 10px;
    }

    .title {
      margin-top: 20px;
      font-size: 20px;
      height: 48px;
      line-height: 24px;
      font-weight: bold;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
    }

    .desc {
      margin-top: 15px;
      /* margin-bottom: 30px; */
      font-size: 14px;
      height: 32px;
      line-height: 16px;
      color: #666666;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        color: #999;
        font-size: 12px;
      }
    }

    .user {
      display: flex;
      align-items: center;
      height: 20px;
      padding: 0 5px 0 3px;
      background: #F3F3F3;
      border-radius: 10px 10px 10px 10px;
      font-size: 12px;
      color: #999;

      div, img {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 3px;
      }
    }
  }
`

export const Chunk = ({ store, list, className = '' }) => {
  const history = useHistory();
  const { isMobile } = store.common;

  const toDetail = (id, link) => () => {
    if (link) {
      window.open(link)
    } else if (id) {
      history.push(`${newPath}/news_detail/${id}`)
    }
  }

  return (
    <Root className={`${className} ${isMobile ? 'sub-mobile' : ''}`}>
      {list.map(({ id, link, title, desc, thumb, ava, name, date }, key) => (
        <li key={key} onClick={toDetail(id, link)}>
          <div><img src={thumb} width={360} height={203} /></div>
          <div className="p10">
            <div className="title">
              {title}
            </div>
            <div className="desc">
              {desc}
            </div>
            {/* <div className="info">
              <div className="user">
                {ava && <div><img src={ava} height={14} /></div>}
                <span>{name}</span>
              </div>
              <span>{date}</span>
            </div> */}
          </div>
        </li>
      ))}
    </Root>
  )
}

export default withRouter(inject("store")(observer(Chunk)))
